import cn from 'classnames'
import { memo, PropsWithChildren, useCallback } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Tooltip } from 'core-components/library/tooltip'

import { renderItemContent } from '../../helpers/renderItemContent'

import { IItemProps } from './models'

import styles from './Item.module.scss'

export const Item = memo<PropsWithChildren<IItemProps>>(
  ({ children, className, onClick, icon, isDisabled, isVisible = true, innerRef, tip = '' }) => {
    const isTooltipDisabled = !tip
    const isIconHidden = !icon

    /** classnames */
    const itemClass = cn(styles.item, { [styles.disabled]: isDisabled })
    const iconClass = cn(icon, styles.icon, { [styles.hidden]: isIconHidden })

    const handleOnClick = useCallback(() => {
      if (onClick && !isDisabled) {
        onClick()
      }
    }, [isDisabled, onClick])

    const renderTooltipContent = useCallback(() => <Translation text={tip} span />, [tip])

    if (!isVisible) {
      return null
    }

    return (
      <Tooltip disabled={isTooltipDisabled} tipContent={renderTooltipContent}>
        <div
          className={cn(itemClass, className)}
          onClick={handleOnClick}
          onMouseDown={handleOnClick}
          role="button"
          ref={innerRef}
        >
          <i className={iconClass} />
          {renderItemContent(children)}
        </div>
      </Tooltip>
    )
  }
)
